class TrackingHandler {
  state = false;
  consensi = {};
  functions = [];
  scripts = [];

  constructor() {
    this.consensi["tecnici"] = true;
    this.consensi["marketing"] = false;
    this.consensi["analytics"] = false;
  }

  setState(consensi) {
    let _ = this;
    _.state = true;
    Object.keys(_.consensi).forEach(function (key) {
      _.consensi[key] =
        typeof consensi[key] !== "undefined" && consensi[key] === true
          ? true
          : false;
    });
    _.appendScripts();
    _.printScripts();
    _.executeAppended();
  }

  getState() {
    return this.state;
  }

  getConsensi() {
    if (this.state) {
      return this.consensi;
    } else {
      return false;
    }
  }

  appendFunction(funzione, types = []) {
    let _ = this;
    let func = { execute: funzione, types: types };
    if (!_.state) {
      _.functions.push(func);
    } else {
      _.executeFunction(func);
    }
  }

  appendScripts() {
    let _ = this;
    let scriptsToAppend = document.querySelectorAll("[append_consent]");
    scriptsToAppend.forEach(function (noScript) {
      let script = {
        id: noScript.dataset?.append ? noScript.dataset.append : "html head",
        types: noScript.dataset?.types ? noScript.dataset.types.split(",") : [],
      };

      let tag = noScript.dataset?.tag ? noScript.dataset.tag : "script";
      var scriptCode = document.createElement(tag);
      scriptCode.async = noScript.dataset.async == true ? true : false;
      scriptCode.src = noScript.dataset.src;

      script["scriptCode"] = scriptCode;

      if (!_.state) {
        _.scripts.push(script);
      } else {
        _.printSingleScript(script);
      }
    });
  }

  printScripts() {
    let _ = this;
    _.scripts.forEach(function (script) {
      printSingleScript(script);
    });
  }

  printSingleScript(script) {
    let _ = this;
    let container = document.querySelector(script.id);
    let print = true;

    if (container) {
      script.types.forEach(function (type) {
        print &=
          typeof _.consensi[type] !== "undefined" && _.consensi[type] === true;
      });
      if (print) {
        container.appendChild(script.scriptCode);
      }
    }
  }

  executeAppended() {
    let _ = this;
    _.functions.forEach((funzione) => {
      _.executeFunction(funzione);
    });
  }

  executeFunction(funzione) {
    let execute = true;
    let _ = this;
    if (
      typeof funzione.types !== "undefined" &&
      Array.isArray(funzione.types)
    ) {
      funzione.types.forEach(function (type) {
        execute &=
          typeof _.consensi[type] !== "undefined" && _.consensi[type] === true;
      });

      if (typeof funzione.execute === "function" && execute) {
        funzione.execute();
      }
    }
  }
}
